import { render, staticRenderFns } from "./LocationSubMenu.vue?vue&type=template&id=132d41d9&"
import script from "./LocationSubMenu.vue?vue&type=script&lang=js&"
export * from "./LocationSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports